import { useLoadingStore } from "@/stores/loading"

const sleep = millis => new Promise(resolve => setTimeout(resolve, millis));

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async doRegister(context, args){
      const { __startLoading: startLoading, __endLoading: endLoading } = useLoadingStore()
      try{
        startLoading();
        const firstArgs = {
          ...args,
          __apiOptions: { noDisplayLoading: true },
        }
        const firstResult = await context.dispatch('api/registerAccount1', firstArgs, { root: true })
        if(!firstResult){
          return;
        }
        if(firstResult === 'EXPIRED_TOKEN'){
          return firstResult;
        }
        let pollingMillisec = firstResult.polling_millisec
        let jobCode = firstResult.job_code
        let result = null;
        for(;;){
          // 完了
          if(!pollingMillisec || !jobCode){
            return result
          }
          await sleep(pollingMillisec);
          const loopArgs = {
            job_code: jobCode,
            __apiOptions: { noDisplayLoading: true },
          }
          result = await context.dispatch('api/registerAccount2', loopArgs, { root: true })
          if(!result){
            return;
          }
          pollingMillisec = result.polling_millisec
          jobCode = result.job_code
        }
      }finally{
        endLoading();
      }
    },
  },
}
